module.exports = __webpack_public_path__ + "img/button-close-modal.f9ba9457.svg";